import angular from 'angular';
import uiRouter from 'angular-ui-router';

import { COMPANY_ADMIN, SYS_ADMIN } from 'config/permissions/roles';
import companyComponent from './company.component';
import companyAddForm from './company-add-form/company-add-form.module';
import companyEditForm from './company-edit-form/company-edit-form.module';

export default
  angular.module('components.app.admin.company', [
    uiRouter,
    companyAddForm,
    companyEditForm
  ])
    .component('company', companyComponent)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('company', {
          parent: 'app',
          url: '/companies/{id:int}',
          component: 'company',
          data: {
            permissions: {
              only: [COMPANY_ADMIN, SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          },
          resolve: {
            accessLevels: AuthService => AuthService.getAccessLevels(),
            company: (CompanyService, $stateParams) =>
              CompanyService.getCompany($stateParams.id).then(r => r.data),
            user: (AccountService, AuthService, currentUser) =>
              AccountService.getAccount(currentUser.UserId).then(r => r.data),
            locked: () => true
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/admin/company/company.module.js